/**
 * What kind of rave it is (the user, 2026-10-26: "add also a filter by type of the rave —
 * psytrance etc."). A FIXED list, a rave may be several; stored as slugs on
 * `tenancy.festival.types` (a CHECK keeps them to this list — change both together).
 * Find a rave in the phone app filters and makes a row per type. The values are researched
 * from public sources (the other session, as crowd size) or set by the rave's admin.
 */
export const RAVE_TYPES = [
  'psytrance', 'goa', 'progressive', 'techno', 'house', 'trance', 'drum-and-bass',
  'dubstep-and-bass', 'hardstyle', 'edm', 'ambient-and-chill', 'multi-genre',
] as const;

export type RaveType = (typeof RAVE_TYPES)[number];

/** The English name of each type — the app translates it (`tr`). */
export const RAVE_TYPE_NAMES: Record<RaveType, string> = {
  psytrance: 'Psytrance', goa: 'Goa', progressive: 'Progressive', techno: 'Techno', house: 'House',
  trance: 'Trance', 'drum-and-bass': 'Drum & Bass', 'dubstep-and-bass': 'Dubstep & Bass',
  hardstyle: 'Hardstyle', edm: 'EDM / Mainstage', 'ambient-and-chill': 'Ambient & Chill', 'multi-genre': 'Multi-genre',
};

const KNOWN = new Set<string>(RAVE_TYPES);

export function isRaveType(value: unknown): value is RaveType {
  return typeof value === 'string' && KNOWN.has(value);
}

/** The known types of a list, each once, in the list's order. */
export function raveTypesOf(values: readonly unknown[] | null | undefined): RaveType[] {
  const have = new Set((values ?? []).filter(isRaveType));
  return RAVE_TYPES.filter((t) => have.has(t));
}
